export const EntityType = {
	PLAYER: "player",
	ENEMY: "enemy",
	BOMB: "bomb",
	TERRAIN: "terrain"
} as const;